import { FC } from 'react'
import { redirect } from 'react-router-dom'
import './card.css'

// COMPONENTS
import AddToWalletButton from '@components/atoms/add-to-wallet-button'
import Card from '@components/atoms/card'

// TYPES
import type { RouteObject } from 'react-router-dom'

// UTILITIES
import { parseTeraUserData } from '@schemas'
import { createAuthenticatedLoader, useLoader } from '@utils/loaders'


const Component: FC<{}> = () => {
    const { virtualCard, address } = useLoader<typeof loader>()
    const activeGroup = virtualCard?.activeGroup
    const status = !!activeGroup ? 'active' : 'not active'

    return (
        <div className='flex flex-col gap-4'>
            <Card>
                <div className="flex flex-row flex-wrap items-center justify-between">
                    <p className="text-body-2 text-gray-500"><strong>Card Status</strong></p>
                    <p className="text-body"><strong className={`text-${status === 'active' ? 'green-600' : 'red-500'}`}>{status === 'active' ? 'Active' : 'Not Active'}</strong></p>
                </div>
                <p className="text-body-2 text-gray-500">You can only use this card with one group at a time!</p>
            </Card>
            <Card>
                <div className="flex flex-row flex-wrap items-center justify-between">
                    <p className="text-body"><strong>Billing Address</strong></p>
                    {address?.line1 ? (
                        <div className="flex flex-col text-right">
                            <p className="text-body text-gray-500"><strong>{address.line1}</strong></p>
                            <p className="text-body text-gray-500"><strong>{address.line2}</strong></p>
                            <p className="text-body-2 text-gray-500">{address.city}, {address.state} {address.postal_code}</p>
                        </div>
                    ) : <p className="text-body-2 text-gray-500">No saved billing address</p>}
                </div>
            </Card>
        </div>)
}

const loader = createAuthenticatedLoader(async ({ }, Clerk) => {
    const tera = parseTeraUserData(Clerk.user?.publicMetadata.tera)
    if (!tera.address?.line1) return redirect('./add-billing')
    else return parseTeraUserData(Clerk.user?.publicMetadata.tera)
})

const UserCardDefaultRoute: RouteObject = {
    index: true,
    Component,
    loader,
}

export { UserCardDefaultRoute }
